module.exports = __webpack_public_path__ + "img/type_4.44e51a40.png";